import { render } from "./BaseLayout.vue?vue&type=template&id=7c5db212&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=7c5db212&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7c5db212"
/* hot reload */
if (module.hot) {
  script.__hmrId = "7c5db212"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7c5db212', script)) {
    api.reload('7c5db212', script)
  }
  
  module.hot.accept("./BaseLayout.vue?vue&type=template&id=7c5db212&scoped=true", () => {
    api.rerender('7c5db212', render)
  })

}

script.__file = "src/layout/BaseLayout.vue"

export default script